import React, { Component } from "react";
import TranslationFile from "../../15-Translation/locale/Translation_apps.json";
import { Toast } from "primereact/toast";
import Sidebar from "../SRUSidebar/SRUSidebar";
import Footer_contact_tab from "../../Footerpage/Footer_contact_tab";
import ScrolltoTop from "../../ScrollTop/ScrollTop";
import SRUNavBarHeader from "../SRUNavBarHeader/SRUNavBarHeader";
import { setUserSessionAuthKey } from "../../../Component/commonUtils";
import { Button } from "primereact/button";
import { connect } from "react-redux";
import "./INK2.css";
import { Row } from "react-bootstrap";
import { Tooltip } from "primereact/tooltip";
import Col from "react-bootstrap/Col";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import axios from "axios";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import moment from "moment";
import { InputTextarea } from "primereact/inputtextarea";
import { FcInfo } from "react-icons/fc";
import { RiArrowDownSFill } from "react-icons/ri";
import { Helmet } from "react-helmet-async";

import { ProgressSpinner } from "primereact/progressspinner";

let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
let INK2TemplateReqArray = [];
let userSelectedLanguage;
let tabTitleArray = [],
  linkSharedUser,
  sruINK2TemplateResponse = {},
  sruINK2TemplateReqArray = [];
let sruReportHeaderRequestObj = {
    reportGUID: "",
    companyName: "",
    registrationNo: "",
    postalCode: "",
    city: "",
    currentYear: ""
  },
  currentReportGUIDFromUrl,
  selectedForms = [],
  currentPageName = "INK2";

const normalizeYesNoValues = (resp) => {
  Object.keys(resp).forEach((heading) => {
    resp[heading].forEach((item) => {
      if (item.valueType === "Yes/No") {
        item.currentYearValue =
          item.currentYearValue === true || item.currentYearValue === "Yes";
      }
    });
  });

  return resp;
};

const mapStateToProps = (state) => {
  return {
    annualReportType: state.annualReportType.annualReportType.values,
    companyInformation: state.companyInformation.companyInformation.values,
    financialYear: state.financialYear.financialYear,
    sessionDetails: state.sessionDetails,
    login: state.login.login.values,
    sideBarReducer: state.sideBarReducer.sideBarReducer,
    activeSideBar: state.activeSideBar.activeSideBar,
    incomeStatement: state.incomeStatement.incomeStatement,
    currentPageName: state.currentPageName.currentPageName,
    readOnly: state.readOnly.readOnly,
    showWIPStatus: state.showWIPStatus.showWIPStatus
  };
};

class INK2 extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.inputNumberRef = [];

    this.toast = React.createRef();
    this.state = {
      activeIndex: [0],
      checked: true,
      checkedbtn: false,
      sideBarStatus: true,
      latestCustomLineNo: 0,
      reportGUID: "",
      finalSumLbl: "Årets resultat",
      toggleOpen: false,
      headerCount: 0,
      loading: true,
      sruINK2Value: "",
      companyName: "",
      currentFinancialYear: "",
      clickedIndex: null,
      clickedParentIndex: null,
      columnIndex: null,
      currentYear: "",
      currentFromDate: "",
      currentToDate: "",
      fiscalYearPortion: "",
      showTooltip: false,
      tooltipContent: ""
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleChange(toggleOpen) {
    window.scroll(0, 0);
    if (toggleOpen == true) {
      let headerIdxList = [];
      Object.keys(tabTitleArray).map((heading, idx) => {
        headerIdxList.push(idx);
      });
      this.setState({ activeIndex: headerIdxList });
      this.setState({ toggleOpen: false });
    } else {
      let collapse = [];
      this.setState({ activeIndex: collapse });
      this.setState({ toggleOpen: true });
    }
  }

  isParentChecked(num, rows) {
    if (num.parentLineNo === null || num.parentLineNo === undefined) {
      return true;
    }

    const parent = rows.find(
      (item) => item.lineNo === num.parentLineNo && item.valueType === "Yes/No"
    );

    return Boolean(parent?.currentYearValue);
  }

  openAll(resp) {
    let headerIdxList = [];
    Object.keys(resp).map((heading, idx) => {
      headerIdxList.push(idx);
    });
    let open = headerIdxList;
    this.setState({ activeIndex: open });
  }

  convert = (str) =>
    str.split(",").flatMap((s) => {
      if (!s.includes("-")) return +s;
      const [min, max] = s.split("-");
      return Array.from({ length: max - min + 1 }, (_, n) => n + +min);
    });

  handleClickOutside(event) {
    let index = this.state.clickedIndex;
    let inputReference = this.inputNumberRef[index];
    if (this.state.clickedIndex !== null && inputReference) {
      this.setState({ clickedIndex: null });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.state.run) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  componentWillMount() {
    let { currentFromDate, currentToDate } = this.state;
    window.scrollTo(0, 0);
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    let { sideBarReducer, currentPageName, companyInformation } = this.props;
    currentPageName.values = "INK2";
    localStorage.setItem("currentPageName", "INK2");

    let splittedUrl = window.location.href.split("/");
    currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];

    sruReportHeaderRequestObj.reportGUID = currentReportGUIDFromUrl;
    if (userSessionAuthKeyReturnValue) {
      sruINK2TemplateReqArray = [];
      axios
        .get(
          "/SRUHeader/getHeader?reportGuid=" + currentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data.forms != "" && response.data.forms != null) {
            selectedForms = response.data.forms.split(",");
          }

          let companyName = response.data.companyName;
          let registrationNo = response.data.registrationNo;

          let currentYear = response.data.currentYear || "";

          let currentStartingPeriod = "";
          let currentEndingPeriod = "";

          if (currentYear.includes(" - ")) {
            let splittedCurrentYear = currentYear.split(" - ");
            currentStartingPeriod = splittedCurrentYear[0] || "";
            currentEndingPeriod = splittedCurrentYear[1] || "";
          } else {
            currentStartingPeriod = currentYear;
          }
          // let currentYear = response.data.currentYear;
          // let splittedCurrentYear = currentYear.split(" - ");
          // let currentStartingPeriod = splittedCurrentYear[0];
          // let currentEndingPeriod = splittedCurrentYear[1];

          let sruTemplateReq = {
            validFromDate: currentStartingPeriod,
            validToDate: currentEndingPeriod,
            statementType: 1
          };
          sruINK2TemplateReqArray.push(sruTemplateReq);

          this.setState({
            companyName: companyName,
            registrationNo: registrationNo,
            currentYear: currentYear,
            currentFromDate: currentStartingPeriod,
            currentToDate: currentEndingPeriod,
            fiscalYearPortion: response.data.fiscalYearPortion,
            loading: false
          });

          let responseDate = response.data;
          if (responseDate != "" && null != responseDate.reportID) {
            let reportAccessReq = { reportId: responseDate.reportID };

            axios
              .post(
                "/SRUHeader/getAccessStatus",
                reportAccessReq,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                switch (response.data) {
                  case 2:
                    linkSharedUser = 2; //Write
                    break;
                  case 3:
                    linkSharedUser = 3; //Read Only
                    break;
                  case 4:
                    linkSharedUser = 4; //No Access
                    break;
                }
                if (responseDate.companyName != "") {
                  this.setState({
                    companyName: responseDate.companyName
                  });
                }
                if (responseDate.currentYear != "")
                  this.setState({
                    currentFinancialYear: responseDate.currentYear
                  });
              })

              .catch((error) => {
                let noAccessURL =
                  "/income-declaration-2/" +
                  currentReportGUIDFromUrl +
                  "/no-access";
                this.props.history.push(noAccessURL);
              });

            axios
              .get(
                "/SRU/getCompletedPages?reportId=" + responseDate.reportID,
                userSessionAuthKeyReturnValue
              )
              .then((response2) => {
                console.log("SideBar", response2);
                sideBarReducer.values = response2.data;

                sideBarReducer.values.push("My Dashboard");
                sideBarReducer.values.push("Company Information");

                let getPossibleAccessablePages = localStorage.getItem(
                  "sruPossibleAccessablePages"
                );
                let getPossibleAccessablePagesArray = JSON.parse(
                  getPossibleAccessablePages
                );
                getPossibleAccessablePagesArray.push("INK2");

                sideBarReducer.values.push("INK2");
                let updatePossibleNavigationPagesListString = JSON.stringify(
                  getPossibleAccessablePagesArray
                );
                localStorage.setItem(
                  "sruPossibleAccessablePages",
                  updatePossibleNavigationPagesListString
                );
              });
          }

          let getJsonLines = {
            guid: currentReportGUIDFromUrl,
            pageName: "INK2"
          };

          axios
            .post(
              "/SRULines/getLinesJson",
              getJsonLines,
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              let responseData = response.data.ink2;
              if (responseData == undefined) {
                responseData = "";
              }

              if (responseData != "") {
                let jsonConvertedResponseData = normalizeYesNoValues(
                  JSON.parse(responseData)
                );
                console.log("convertedData????????", jsonConvertedResponseData);
                let financialYearFromJsonResponse = [];
                Object.keys(jsonConvertedResponseData).map((i, idx) => {
                  if (i == "financialYear") {
                    financialYearFromJsonResponse = [
                      ...jsonConvertedResponseData[i]
                    ];
                  }
                });

                INK2TemplateReqArray = financialYearFromJsonResponse;

                console.log(
                  "INK2TemplateReqArray????????",
                  INK2TemplateReqArray
                );

                console.log(
                  "jsonConvertedResponseData????????",
                  jsonConvertedResponseData
                );

                delete jsonConvertedResponseData.financialYear;

                tabTitleArray = jsonConvertedResponseData;
                this.openAll(jsonConvertedResponseData);

                axios
                  .get(
                    "/SRU/getCompletedPages?reportId=" + response.data.reportID,
                    userSessionAuthKeyReturnValue
                  )
                  .then((completedStatementTypesResponse) => {
                    console.log(
                      "completedStatementTypesResponse????????",
                      completedStatementTypesResponse
                    );

                    sideBarReducer.values =
                      completedStatementTypesResponse.data;
                    // sideBarGreenTickPages = completedStatementTypesResponse.data;
                    this.setState({
                      reRender: true
                    });
                  });
                this.setState({
                  sruINK2Value: jsonConvertedResponseData,
                  isLoading: false
                });
              } else {
                if (userSessionAuthKeyReturnValue) {
                  INK2TemplateReqArray = [];
                  companyInformation != undefined &&
                    companyInformation.financialYear.length &&
                    companyInformation.financialYear.map(
                      (financialYear, idx) => {
                        let INK2TemplateReq = {
                          validFromDate: moment(financialYear.from).format(
                            "YYYY-MM-DD"
                          ),
                          validToDate: moment(financialYear.to).format(
                            "YYYY-MM-DD"
                          ),
                          statementType: 1
                        };
                        INK2TemplateReqArray.push(INK2TemplateReq);
                      }
                    );
                  axios
                    .post(
                      "/SRUHeader/getSRUTemplateLinesByFY",
                      sruINK2TemplateReqArray,
                      userSessionAuthKeyReturnValue
                    )
                    .then((Response) => {
                      sruINK2TemplateResponse = Response.data;
                      this.dataManipulation(
                        sruINK2TemplateResponse,
                        true,
                        false
                      );

                      tabTitleArray = sruINK2TemplateResponse;
                      this.openAll(sruINK2TemplateResponse);
                    });
                }
              }
            });
        });
    }
  }

  dataManipulation(resp, isInitialRender, isOnChangeCall) {
    let { sruINK2Value } = this.state;
    if (isInitialRender) {
      let normalizedResp = normalizeYesNoValues(resp);
      Object.keys(resp).map((i, idx) => {
        let sortedRespArray = [...resp[i]].sort((a, b) => a.lineNo - b.lineNo);
      });
      this.setState({
        sruINK2Value: normalizedResp
      });
      this.updateLinesTable(normalizedResp);
      this.insertUpdateJSONLines();

      // let responseJson = resp;
      // let currentPageName = localStorage.getItem("currentPageName");
      // let updateJsonTableObj = {
      //   pageName: currentPageName,
      //   guid: currentReportGUIDFromUrl,
      //   json: JSON.stringify(responseJson),
      // };

      // axios
      //   .post(
      //     "/SRULines/insertAndUpdateLinesJsonTable",
      //     updateJsonTableObj,
      //     userSessionAuthKeyReturnValue
      //   )
      //   .then((response) => { });
    }
  }

  handleYesNoChange(checked, num, heading) {
    const { sruINK2Value } = this.state;
    const updatedSruINK2Value = {
      ...sruINK2Value,
      [heading]: sruINK2Value[heading].map((item) => {
        if (item.lineNo === num.lineNo) {
          return {
            ...item,
            currentYearValue: checked
          };
        }

        return item;
      })
    };

    this.setState({ sruINK2Value: updatedSruINK2Value }, () => {
      this.updateLinesTable(updatedSruINK2Value);
      this.insertUpdateJSONLines();
    });
  }
  // handleTextAreaChange(value, num, heading) {
  //   const { sruINK2Value } = this.state;

  //   const updatedValue = {
  //     ...sruINK2Value,
  //     [heading]: sruINK2Value[heading].map((item) =>
  //       item.lineNo == num.lineNo
  //         ? {
  //             ...item,
  //             currentYearValue: value
  //           }
  //         : item
  //     )
  //   };

  //   this.setState({
  //     sruINK2Value: updatedValue
  //   });

  //   this.updateLinesTable(updatedValue);
  //   this.insertUpdateJSONLines();
  // }

  // handleTextAreaChange(value, num, heading) {
  //   const { sruINK2Value } = this.state;

  //   const updatedValue = {
  //     ...sruINK2Value,
  //     [heading]: sruINK2Value[heading].map((item) =>
  //       item.lineNo == num.lineNo
  //         ? {
  //             ...item,
  //             currentYearValue: value
  //           }
  //         : item
  //     )
  //   };

  //   this.setState(
  //     {
  //       sruINK2Value: updatedValue
  //     },
  //     () => {
  //       this.updateLinesTable(updatedValue);
  //       this.insertUpdateJSONLines();
  //     }
  //   );
  // }

  handleTextAreaChange(value, num, heading) {
    const { sruINK2Value } = this.state;

    const currentItem = sruINK2Value[heading]?.find(
      (item) => item.lineNo === num.lineNo
    );

    if (!currentItem) {
      return;
    }

    // Skip if value hasn't changed
    if (currentItem.currentYearValue === value) {
      return;
    }

    const updatedValue = {
      ...sruINK2Value,
      [heading]: sruINK2Value[heading].map((item) =>
        item.lineNo === num.lineNo
          ? {
              ...item,
              currentYearValue: value
            }
          : item
      )
    };

    this.setState(
      {
        sruINK2Value: updatedValue
      },
      () => {
        this.updateLinesTable(updatedValue);
        this.insertUpdateJSONLines();
      }
    );
  }

  handleYesNoChange(value, num, heading) {
    const { sruINK2Value } = this.state;

    const updatedSruINK2Value = {
      ...sruINK2Value,
      [heading]: sruINK2Value[heading].map((item) => {
        if (item.lineNo === num.lineNo) {
          return {
            ...item,
            currentYearValue: value,
            isVisible: value
          };
        }

        return item;
      })
    };

    this.setState({ sruINK2Value: updatedSruINK2Value }, () => {
      this.updateLinesTable(updatedSruINK2Value);
      this.insertUpdateJSONLines();
    });
  }

  // updateLinesTable(currentValue, num) {
  //   let insertLinesArray = [];
  //   let insertLinesObj = {
  //     currentYearValue: currentValue,
  //     isHeader: num["isHeader"],
  //     lineNo: num["lineNo"],
  //     lineType: num["lineType"],
  //     name: num["name"],
  //     no: num["no"],
  //     parentLineNo: num["parentLineNo"],
  //     reportGUID: currentReportGUIDFromUrl,
  //     statementType: "INK2",
  //   };
  //   insertLinesArray.push(insertLinesObj);

  //   if (userSessionAuthKeyReturnValue) {
  //     axios
  //       .post(
  //         "/SRULines/insertAndUpdateLines",
  //         insertLinesArray,
  //         userSessionAuthKeyReturnValue
  //       )
  //       .then((response) => {
  //         if (response.data) {
  //           // this.dataManipulation(INK2Value, false, true);
  //         }
  //       });
  //   }
  // }

  updateLinesTable(resp) {
    let fieldExistsInMultiYear = [],
      lineNoArray = [],
      lineDetailsArray = [];
    Object.keys(resp).map((i, idx) => {
      let sortedRespArray = [...resp[i]].sort((a, b) => a.lineNo - b.lineNo);
      sortedRespArray.map((sortedResp, sortedRespIdx) => {
        sortedResp["currentYearValue"] = sortedResp.currentYearValue;
        sortedResp["reportGUID"] = currentReportGUIDFromUrl;
        sortedResp["mapToAccountNos"] = sortedResp.mapToAccountNos;
      });
    });

    Object.keys(resp).map((i, idx) => {
      let sortedRespArray = [...resp[i]].sort((a, b) => a.lineNo - b.lineNo);
      sortedRespArray.map((sortedResp, sortedRespIdx) => {
        const filtered = sortedRespArray.filter(
          (obj) => obj.lineNo == sortedResp.lineNo
        );
        fieldExistsInMultiYear.push(Object.assign({}, ...filtered));
      });
    });

    fieldExistsInMultiYear.length &&
      fieldExistsInMultiYear.map((i, idx) => {
        if (!lineNoArray.includes(i.lineNo)) {
          lineNoArray.push(i.lineNo);
          lineDetailsArray.push(i);
        }
      });
    if (lineDetailsArray.length > 0) {
      axios
        .post(
          "/SRULines/insertAndUpdateLines",
          lineDetailsArray,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {})
        .catch((error) => {});
      this.setState({
        sruINK2Value: resp
      });
    }
  }

  insertUpdateJSONLines() {
    const { sruINK2Value } = this.state;
    let responseJson = sruINK2Value;

    let updateJsonTableObj = {
      pageName: "INK2",
      guid: currentReportGUIDFromUrl,
      json: JSON.stringify(responseJson)
    };
    axios
      .post(
        "/SRULines/insertAndUpdateLinesJsonTable",
        updateJsonTableObj,
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        let getJsonLines = {
          guid: currentReportGUIDFromUrl,
          pageName: "INK2"
        };
        axios
          .post(
            "/SRULines/getLinesJson",
            getJsonLines,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            let responseData = response.data.ink2;
            if (responseData == undefined) {
              responseData = "";
            }
            if (responseData != "") {
              let jsonConvertedResponseData = JSON.parse(responseData);
            }
          });
      });
  }

  // AmountOnBlur(e, num, heading, field) {
  //   const { sruINK2Value } = this.state;
  //   let custEnteredValue = e.target.value;
  //   console.log("Field Name:", field);
  //   sruINK2Value[heading].map((i, idx) => {
  //     if (i.lineNo == num.lineNo) {
  //       if (field == "Number") {
  //         let spacesRemoved = custEnteredValue
  //           .replaceAll(/\s/g, "")
  //           .replace(/−/g, "-");

  //         // Empty value handling
  //         if (spacesRemoved === "") {
  //           // i["currentYearValue"] = "";
  //           delete i.currentYearValue;
  //         } else if (spacesRemoved === "0") {
  //           i["currentYearValue"] = spacesRemoved;
  //         } else {
  //           let parsedValue = Number(spacesRemoved);

  //           // Invalid number handling
  //           if (isNaN(parsedValue)) {
  //             console.error("Invalid Number Detected", {
  //               object: i,
  //               enteredValue: custEnteredValue,
  //               processedValue: spacesRemoved,
  //               heading: heading,
  //               lineNo: i.lineNo
  //             });

  //             parsedValue = 0;
  //           }
  //           i["currentYearValue"] = Number(parsedValue);
  //         }
  //       } else if (field == "Text") {
  //         i["currentYearValue"] = custEnteredValue;
  //       }
  //     }
  //   });
  //   this.setState({
  //     sruINK2Value: ""
  //   });
  //   this.updateLinesTable(sruINK2Value);
  //   this.insertUpdateJSONLines();
  // }

  AmountOnBlur(e, num, heading, field) {
    const { sruINK2Value } = this.state;
    const custEnteredValue = e.target.value;

    const item = sruINK2Value[heading]?.find((i) => i.lineNo === num.lineNo);

    if (!item) {
      return;
    }

    const previousValue = item.currentYearValue;

    let newValue;

    if (field === "Number") {
      const spacesRemoved = custEnteredValue
        .replaceAll(/\s/g, "")
        .replace(/−/g, "-");

      if (spacesRemoved === "") {
        newValue = undefined;
      } else if (spacesRemoved === "0") {
        newValue = 0;
      } else {
        const parsedValue = Number(spacesRemoved);

        if (isNaN(parsedValue)) {
          console.error("Invalid Number Detected", {
            object: item,
            enteredValue: custEnteredValue,
            processedValue: spacesRemoved,
            heading,
            lineNo: item.lineNo
          });

          newValue = 0;
        } else {
          newValue = parsedValue;
        }
      }
    } else if (field === "Text") {
      newValue = custEnteredValue;
    }

    // Compare normalized values
    const previousNormalized = String(previousValue ?? "");
    const newNormalized = String(newValue ?? "");

    console.log("Previous:", previousNormalized);
    console.log("New:", newNormalized);

    if (previousNormalized === newNormalized) {
      console.log("Value unchanged - skipping update");
      return;
    }

    // Update value
    if (newValue === undefined) {
      delete item.currentYearValue;
    } else {
      item.currentYearValue = newValue;
    }

    this.setState({
      sruINK2Value: ""
    });

    this.updateLinesTable(sruINK2Value);
    this.insertUpdateJSONLines();
  }

  navigateToNextPages(side) {
    console.log("navigate to next page", side);
    const { sessionDetails } = this.props;
    let uuid = sessionDetails.sessionDetails.values.uuid;
    let index = selectedForms.indexOf(currentPageName);

    if (side == "next") {
      // Go To Next Page
      let nextPageName = selectedForms[index + 1];

      console.log("selectedForms", nextPageName);

      // SPECIAL CASE
      // Only INK2 selected
      if (selectedForms.length === 1 && selectedForms[0] === "INK2") {
        const user = JSON.parse(localStorage.getItem("rebelSkoolUser") || "{}");
        if (!user?.emailID) {
          this.toast.current?.show({
            severity: "info",
            summary: "Info",
            detail:
              TranslationFile.pleaseLoginToProceedFurther[userSelectedLanguage],
            life: 5000
          });
          document.getElementsByClassName("user-btn")[0]?.click();
          return;
        }

        nextPageName = "reviewAndSend";
      }

      if (nextPageName != "" && nextPageName != undefined) {
        // Go To INK2R/INK2S/reviewAndSend
        this.props.history.push(
          "/income-declaration-2/" + uuid + "/" + nextPageName
        );
      }
    } else {
      // Go To Previous Page
      let previousPageName = selectedForms[index - 1];

      if (previousPageName == undefined) {
        // Go To Company Info Page
        this.props.history.push(
          "/income-declaration-2/" + uuid + "/companyInfo"
        );
      } else {
        this.props.history.push(
          "/income-declaration-2/" + uuid + "/" + previousPageName
        );
      }
    }
  }

  sideBarStatus = (e) => {
    console.log("SRU -> SideBar -> ", e);
    this.setState({
      sideBarStatus: e
    });
  };

  sideBarCallback = (value) => {
    if (value) {
      this.toast.current?.show({
        severity: "info",
        summary: "Info",
        detail: TranslationFile.CompleteCurrentPageText[userSelectedLanguage],
        life: 5000
      });
      this.setState({
        reRender: true
      });
    }
  };

  accordionHeader(header) {
    return (
      <Row>
        <Col
          xs={5}
          sm={5}
          md={5}
          lg={5}
          xl={5}
          style={{ width: "41%", marginTop: "7px", marginLeft: "2%" }}
        >
          <label
            className="SRU-INK2FieldsStyle"
            style={{ marginLeft: "-21px" }}
          >
            {header}
          </label>
        </Col>
      </Row>
    );
  }
  setClickedIndex(idx, parentIdx, number) {
    this.setState({
      showTooltip: true
    });
    this.setState((prevState) => ({
      clickedIndex: prevState.clickedIndex === idx ? null : idx
    }));
    this.setState({
      // clickedIndex: idx,
      clickedParentIndex: parentIdx,
      columnIndex: number
    });
  }

  setRef = (index) => (el) => {
    this.inputNumberRef[index] = el;
  };

  render() {
    const {
      sideBarStatus,
      toggleOpen,
      activeIndex,
      sruINK2Value,
      companyName,
      registrationNo,
      clickedIndex,
      clickedParentIndex,
      columnIndex,
      booleanOptions,
      selectedBooleanOptions,
      fiscalYearPortion,
      showTooltip,
      tooltipContent,
      checkedbtn,
      loading
    } = this.state;
    let { showWIPStatus } = this.props;
    let pageUnderWIP = false;
    if (showWIPStatus.values != undefined) {
      if (showWIPStatus.values) {
        pageUnderWIP = true;
      } else {
        pageUnderWIP = false;
      }
    }
    return (
      <div className="SRU-INK2">
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconAppText[userSelectedLanguage]
              : TranslationFile.FaviconAppText.en}
          </title>
        </Helmet>
        {/* <Toast
          ref={(el) => {
            this.toast = el;
          }}
          className="SRU-companyInfoErrorToast"
          style={{ marginTop: "34%" }}
        ></Toast> */}

        <SRUNavBarHeader
          callBack={this.callback}
          isAppPortal={true}
          isHomePage={false}
        />

        <div
          className={
            pageUnderWIP
              ? "SRU-companyInfoSideBarWithWIP"
              : "SRU-companyInfoSideBar"
          }
        >
          <Toast ref={this.toast} />

          <Sidebar
            children="INK2"
            sideBarStatus={this.sideBarStatus.bind(this)}
            sideBarCallback={this.sideBarCallback.bind(this)}
          />
        </div>
        {/* <br></br> */}

        {loading ? (
          <div className="sru-loading-container">
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="4"
              animationDuration=".5s"
            />
          </div>
        ) : (
          <>
            <div>
              <Row
                className={
                  sideBarStatus
                    ? "SRU-INK2FYStyle"
                    : "SRU-INK2FYStyle-sidebar-close"
                }
              >
                <div className="SRU-INK2parent">
                  <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                    <div>
                      <div className="SRU-Page_Title_INK2">
                        <div className="SRU-Page_Title_T1_INK2">
                          {this.state.companyName} ({this.state.registrationNo})
                          <div className="SRU-INK2FYMainDiv">
                            {fiscalYearPortion}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </div>
              </Row>
            </div>

            <div
              className={
                sideBarStatus ? "SRU-INK2SideBarOpen" : "SRU-INK2SideBarClose"
              }
            >
              <div>
                <Row className="SRU-INK2ParentRow">
                  <Col
                    style={{
                      width: "100%"
                    }}
                  >
                    {sruINK2Value != undefined && (
                      <div className="INK2-main-grid">
                        {Object.keys(sruINK2Value).map((heading, parentIdx) => {
                          let responseArray = [...sruINK2Value[heading]].sort(
                            (a, b) => a.lineNo - b.lineNo
                          );
                          let header = responseArray[0].name;
                          let rows = responseArray.filter(
                            (num) => num.lineNo !== responseArray[0].lineNo
                          );

                          return (
                            <div className="INK2-section-card" key={parentIdx}>
                              <div
                                className="INK2-section-header"
                                style={{ cursor: "default" }}
                              >
                                {header}
                              </div>

                              <div className="INK2-table">
                                {rows.map((num, idx) => {
                                  // 1. Header
                                  if (
                                    num.lineType === "Header" &&
                                    num.lineLevel > 1
                                  ) {
                                    return (
                                      <div
                                        className="INK2-subheader-row"
                                        key={idx}
                                      >
                                        <div
                                          className="INK2-subheader-label"
                                          style={{
                                            fontWeight: "bold",
                                            textAlign: "left",
                                            paddingTop: "10px",
                                            paddingLeft: "10px",
                                            textDecoration: "underline"
                                          }}
                                        >
                                          {num.name}
                                        </div>
                                      </div>
                                    );
                                  }

                                  // 2. Checkbox / Yes-No
                                  if (num.valueType === "Yes/No") {
                                    return (
                                      <div
                                        className="INK2-row INK2-checkbox-row"
                                        key={idx}
                                        style={{
                                          gridTemplateColumns: "1fr"
                                        }}
                                      >
                                        <div className="INK2-label">
                                          <div className="INK2-checkbox-item">
                                            <Checkbox
                                              inputId={`yes-${parentIdx}-${idx}`}
                                              checked={Boolean(
                                                num.currentYearValue
                                              )}
                                              disabled={linkSharedUser == 3}
                                              binary
                                              onChange={(e) => {
                                                this.handleYesNoChange(
                                                  e.checked,
                                                  num,
                                                  heading
                                                );
                                              }}
                                            />
                                          </div>

                                          <span
                                            className="name"
                                            style={{ cursor: "pointer" }}
                                            data-pr-tooltip={
                                              num.mapToAccountNos
                                            }
                                          >
                                            {num.name}
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  }

                                  // 3. Comment / TextArea
                                  if (num.valueType === "TextArea") {
                                    const parent = rows.find(
                                      (item) =>
                                        item.lineNo === num.parentLineNo &&
                                        item.valueType === "Yes/No"
                                    );

                                    const isParentChecked = Boolean(
                                      parent?.currentYearValue
                                    );

                                    return (
                                      <div
                                        className="INK2-comment-row"
                                        key={idx}
                                        style={{
                                          margin: "10px 0px",
                                          width: "90%",
                                          alignSelf: "center"
                                        }}
                                      >
                                        <InputTextarea
                                          className="INK2-comment-textarea"
                                          style={{
                                            borderRadius: "5px",
                                            border: "1px solid #ccc"
                                          }}
                                          defaultValue={
                                            num.currentYearValue || ""
                                          }
                                          disabled={
                                            !isParentChecked ||
                                            linkSharedUser == 3
                                          }
                                          placeholder={num?.name || ""}
                                          onBlur={(e) => {
                                            this.handleTextAreaChange(
                                              e.target.value,
                                              num,
                                              heading
                                            );
                                          }}
                                          autoResize
                                          rows={4}
                                        />
                                      </div>
                                    );
                                  }

                                  // 4. Number
                                  return (
                                    <div className="INK2-row" key={idx}>
                                      <div className="INK2-label">
                                        <span className="serial">
                                          {num.serialNumber}
                                        </span>
                                        <Tooltip
                                          target=".name"
                                          position="top"
                                          pt={{
                                            root: {
                                              style: {
                                                boxShadow: "none",
                                                filter: "none"
                                              }
                                            },
                                            token: {
                                              style: { boxShadow: "none" }
                                            } // Clears inner shadow tokens if any
                                          }}
                                        />
                                        <span
                                          className="name"
                                          style={{ cursor: "pointer" }}
                                          data-pr-tooltip={num.mapToAccountNos}
                                        >
                                          {num.name}
                                        </span>
                                      </div>

                                      <div className="INK2-input-cell">
                                        <div className="INK2-input-wrapper">
                                          <div className="INK2-input">
                                            <InputNumber
                                              value={
                                                num.currentYearValue === ""
                                                  ? null
                                                  : num.currentYearValue
                                              }
                                              className={
                                                num.lineType == "LineSum"
                                                  ? "SRU-ISAmountBoxDisabled"
                                                  : ""
                                              }
                                              disabled={linkSharedUser == 3}
                                              // placeholder="0"
                                              mode="decimal"
                                              locale="sv-SE"
                                              ref={this.setRef(idx)}
                                              onClick={() => {
                                                this.setClickedIndex(
                                                  idx,
                                                  parentIdx,
                                                  1
                                                );
                                              }}
                                              onBlur={(e) => {
                                                this.AmountOnBlur(
                                                  e,
                                                  num,
                                                  heading,
                                                  "Number"
                                                );
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </Col>
                </Row>
              </div>

              <center>
                <Button
                  label="Previous"
                  aria-label="year-btn-save"
                  onClick={() => this.navigateToNextPages("previous")}
                  style={{
                    marginTop: "2%",
                    marginRight: "1%"
                  }}
                  // className="ISSaveBtn"
                  className="SRU-year-btn-save"
                />
                <Button
                  label="Next"
                  aria-label="year-btn-save"
                  onClick={() => this.navigateToNextPages("next")}
                  style={{
                    marginTop: "2%"
                  }}
                  // className="ISSaveBtn"
                  className="SRU-year-btn-save"
                />
              </center>
              <br></br>
              <br></br>
            </div>
          </>
        )}
        <ScrolltoTop />
        <Footer_contact_tab
          sideBar={this.state.sideBarStatus}
          isCorpPortal={false}
          isHomePage={true}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(INK2);
